module.exports = __webpack_public_path__ + "assets/80a155fa228b04147996f7506c97c5c3.json";